<script>
import {push} from "svelte-spa-router";
</script>

<section class="container" id="summary">
    <div class="summary">
        <div class="row">
            <div class="offset-xl-3 col-xl-6">
                <div class="summary-header">
                    <div class="row d-none d-md-flex">
                        <div class="col-2">
                            <div class="header-number checked">
                                <h1>1</h1>
                                <span>súhrn</span>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="line"></div>
                        </div>
                        <div class="col-2">
                            <div class="header-number checked">
                                <h1>2</h1>
                                <span>dodacie údaje</span>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="line"></div>
                        </div>
                        <div class="col-2">
                            <div class="header-number active">
                                <h1>3</h1>
                                <span>dokončenie</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="summary-body">
                    <div class="summary-created">
                        <i class="text-danger far fa-fw fa-times-circle"></i>
                        <h2>Objednávka bola zrušená!</h2>
                        <p>Platba bola zrušená. Objednávka bola stornovaná.</p>
                    </div>
                </div>
                <div class="summary-footer">
                    <div class="footer-buttons">
                        <button class="btn-red" on:click={() => push('/')}>SPÄŤ DO OBCHODU<i class="fas fa-arrow-right ml-2"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>